/**
 * A selectable category facet for the Service/Repair Finder. `value` is the full Maintenance:: tag name the
 * API returns on ServiceRepairResult.tags (so client-side filtering matches against it); `label` is the UI
 * text. Mirrors {@link FboFacetOption}. Service/repair businesses carry any `Maintenance::` tag; the facets
 * are the Airframe / Avionics / Powerplant / Propeller / Interior / Exterior / Rotor categories, each with a
 * Manufacturers subsection where applicable. Service groups use AND logic and Manufacturer subsections use OR
 * logic (see SearchPageComponent.filterServiceRepairs).
 */
export interface ServiceRepairFacetOption {
  label: string;
  value: string;
}

export const SERVICE_REPAIR_AIRFRAME_OPTIONS: ServiceRepairFacetOption[] = [
  { label: '100 Hour inspection', value: 'Maintenance::Airframe::100 Hour inspection' },
  { label: '50 Hour inspection', value: 'Maintenance::Airframe::50 Hour inspection' },
  { label: 'Aircraft On Ground (AOG)', value: 'Maintenance::Airframe::Aircraft On Ground (AOG)' },
  { label: 'Aircraft Refurbishment/Modification', value: 'Maintenance::Airframe::Aircraft Refurbishment/Modification' },
  { label: 'Airship', value: 'Maintenance::Airframe::Airship' },
  { label: 'Annual Inspection', value: 'Maintenance::Airframe::Annual Inspection' },
  { label: 'Balloon', value: 'Maintenance::Airframe::Balloon' },
  { label: 'Certified Aircraft Weighing', value: 'Maintenance::Airframe::Certified Aircraft Weighing' },
  { label: 'Classic', value: 'Maintenance::Airframe::Classic' },
  { label: 'Composite', value: 'Maintenance::Airframe::Composite' },
  { label: 'FAA Repair', value: 'Maintenance::Airframe::FAA Repair' },
  { label: 'Fabric', value: 'Maintenance::Airframe::Fabric' },
  { label: 'Glider', value: 'Maintenance::Airframe::Glider' },
  { label: 'Large Aircraft (>12,500 lbs)', value: 'Maintenance::Airframe::Large Aircraft (>12,500 lbs)' },
  { label: 'Light Sport', value: 'Maintenance::Airframe::Light Sport' },
  { label: 'Major repair', value: 'Maintenance::Airframe::Major repair' },
  { label: 'Minor repair', value: 'Maintenance::Airframe::Minor repair' },
  { label: 'Nondestructive Testing (NDT)', value: 'Maintenance::Airframe::Nondestructive Testing (NDT)' },
  { label: 'Pre-sales Inspection', value: 'Maintenance::Airframe::Pre-sales Inspection' },
  { label: 'Progressive/Phase Inspection', value: 'Maintenance::Airframe::Progressive/Phase Inspection' },
  { label: 'Rotorcraft', value: 'Maintenance::Airframe::Rotorcraft' },
  { label: 'Seaplane Floats', value: 'Maintenance::Airframe::Seaplane Floats' },
  { label: 'Small Aircraft', value: 'Maintenance::Airframe::Small Aircraft' },
  { label: 'Ultralight', value: 'Maintenance::Airframe::Ultralight' },
  { label: 'Warbirds', value: 'Maintenance::Airframe::Warbirds' },
];

export const SERVICE_REPAIR_AIRFRAME_MANUFACTURER_OPTIONS: ServiceRepairFacetOption[] = [
  { label: 'Aeroprakt', value: 'Maintenance::Airframe::Manufacturers::Aeroprakt' },
  { label: 'Air Tractor', value: 'Maintenance::Airframe::Manufacturers::Air Tractor' },
  { label: 'Airbus', value: 'Maintenance::Airframe::Manufacturers::Airbus' },
  { label: 'American Champion', value: 'Maintenance::Airframe::Manufacturers::American Champion' },
  { label: 'Aviat Aircraft', value: 'Maintenance::Airframe::Manufacturers::Aviat Aircraft' },
  { label: 'Beechcraft', value: 'Maintenance::Airframe::Manufacturers::Beechcraft' },
  { label: 'Bell', value: 'Maintenance::Airframe::Manufacturers::Bell' },
  { label: 'Bellanca', value: 'Maintenance::Airframe::Manufacturers::Bellanca' },
  { label: 'Boeing', value: 'Maintenance::Airframe::Manufacturers::Boeing' },
  { label: 'Bombardier', value: 'Maintenance::Airframe::Manufacturers::Bombardier' },
  { label: 'Cessna', value: 'Maintenance::Airframe::Manufacturers::Cessna' },
  { label: 'Cirrus', value: 'Maintenance::Airframe::Manufacturers::Cirrus' },
  { label: 'Dassault', value: 'Maintenance::Airframe::Manufacturers::Dassault' },
  { label: 'Diamond', value: 'Maintenance::Airframe::Manufacturers::Diamond' },
  { label: 'Embraer', value: 'Maintenance::Airframe::Manufacturers::Embraer' },
  { label: 'Eurocopter', value: 'Maintenance::Airframe::Manufacturers::Eurocopter' },
  { label: 'Flight Design', value: 'Maintenance::Airframe::Manufacturers::Flight Design' },
  { label: 'Grumman', value: 'Maintenance::Airframe::Manufacturers::Grumman' },
  { label: 'Gulfstream', value: 'Maintenance::Airframe::Manufacturers::Gulfstream' },
  { label: 'Hawker Beechcraft', value: 'Maintenance::Airframe::Manufacturers::Hawker Beechcraft' },
  { label: 'Honda Jet', value: 'Maintenance::Airframe::Manufacturers::Honda Jet' },
  { label: 'Learjet', value: 'Maintenance::Airframe::Manufacturers::Learjet' },
  { label: 'Luscombe', value: 'Maintenance::Airframe::Manufacturers::Luscombe' },
  { label: 'Maule', value: 'Maintenance::Airframe::Manufacturers::Maule' },
  { label: 'Mooney', value: 'Maintenance::Airframe::Manufacturers::Mooney' },
  { label: 'Piaggio', value: 'Maintenance::Airframe::Manufacturers::Piaggio' },
  { label: 'Pilatus', value: 'Maintenance::Airframe::Manufacturers::Pilatus' },
  { label: 'Piper', value: 'Maintenance::Airframe::Manufacturers::Piper' },
  { label: 'Pipistrel', value: 'Maintenance::Airframe::Manufacturers::Pipistrel' },
  { label: 'Robinson', value: 'Maintenance::Airframe::Manufacturers::Robinson' },
  { label: 'Sikorsky', value: 'Maintenance::Airframe::Manufacturers::Sikorsky' },
  { label: 'Socata', value: 'Maintenance::Airframe::Manufacturers::Socata' },
  { label: 'Stearman', value: 'Maintenance::Airframe::Manufacturers::Stearman' },
  { label: 'Tecnam', value: 'Maintenance::Airframe::Manufacturers::Tecnam' },
  { label: 'Vans', value: 'Maintenance::Airframe::Manufacturers::Vans' },
  { label: 'Waco', value: 'Maintenance::Airframe::Manufacturers::Waco' },
  { label: 'de Havilland', value: 'Maintenance::Airframe::Manufacturers::de Havilland' },
];

export const SERVICE_REPAIR_AVIONICS_OPTIONS: ServiceRepairFacetOption[] = [
  { label: 'ADS-B', value: 'Maintenance::Avionics::ADS-B' },
  { label: 'Altimeter', value: 'Maintenance::Avionics::Altimeter' },
  { label: 'Altimeter/Pitot-Static System Check', value: 'Maintenance::Avionics::Altimeter/Pitot-Static System Check' },
  { label: 'Autopilot', value: 'Maintenance::Avionics::Autopilot' },
  { label: 'EFIS', value: 'Maintenance::Avionics::EFIS' },
  { label: 'Electrical System', value: 'Maintenance::Avionics::Electrical System' },
  { label: 'Emergency Locator Transmitter ELT', value: 'Maintenance::Avionics::Emergency Locator Transmitter ELT' },
  { label: 'FAA Repair', value: 'Maintenance::Avionics::FAA Repair' },
  { label: 'GPS', value: 'Maintenance::Avionics::GPS' },
  { label: 'Gyroscopic', value: 'Maintenance::Avionics::Gyroscopic' },
  { label: 'Multi Function Display MFD', value: 'Maintenance::Avionics::Multi Function Display MFD' },
  { label: 'Nav Com', value: 'Maintenance::Avionics::Nav Com' },
  { label: 'Primary Flight Display PFD', value: 'Maintenance::Avionics::Primary Flight Display PFD' },
  { label: 'Radar', value: 'Maintenance::Avionics::Radar' },
  { label: 'Traffic Collision Avoidance TCAS', value: 'Maintenance::Avionics::Traffic Collision Avoidance TCAS' },
  { label: 'Transponders', value: 'Maintenance::Avionics::Transponders' },
  { label: 'Weather Systems', value: 'Maintenance::Avionics::Weather Systems' },
];

export const SERVICE_REPAIR_AVIONICS_MANUFACTURER_OPTIONS: ServiceRepairFacetOption[] = [
  { label: 'Advanced Flight Systems', value: 'Maintenance::Avionics::Manufacturers::Advanced Flight Systems' },
  { label: 'Aerosonic', value: 'Maintenance::Avionics::Manufacturers::Aerosonic' },
  { label: 'Aircell', value: 'Maintenance::Avionics::Manufacturers::Aircell' },
  { label: 'Appareo', value: 'Maintenance::Avionics::Manufacturers::Appareo' },
  { label: 'Aspen', value: 'Maintenance::Avionics::Manufacturers::Aspen' },
  { label: 'Avidyne', value: 'Maintenance::Avionics::Manufacturers::Avidyne' },
  { label: 'Becker', value: 'Maintenance::Avionics::Manufacturers::Becker' },
  { label: 'Bendix-King', value: 'Maintenance::Avionics::Manufacturers::Bendix-King' },
  { label: 'Century', value: 'Maintenance::Avionics::Manufacturers::Century' },
  { label: 'Cobham', value: 'Maintenance::Avionics::Manufacturers::Cobham' },
  { label: 'Collins', value: 'Maintenance::Avionics::Manufacturers::Collins' },
  { label: 'DAC International', value: 'Maintenance::Avionics::Manufacturers::DAC International' },
  { label: 'Dynon', value: 'Maintenance::Avionics::Manufacturers::Dynon' },
  { label: 'Electronics International', value: 'Maintenance::Avionics::Manufacturers::Electronics International' },
  { label: 'Flight Display Systems', value: 'Maintenance::Avionics::Manufacturers::Flight Display Systems' },
  { label: 'FreeFlight Systems', value: 'Maintenance::Avionics::Manufacturers::FreeFlight Systems' },
  { label: 'Garmin', value: 'Maintenance::Avionics::Manufacturers::Garmin' },
  { label: 'Genesys Aerosystems', value: 'Maintenance::Avionics::Manufacturers::Genesys Aerosystems' },
  { label: 'Honeywell', value: 'Maintenance::Avionics::Manufacturers::Honeywell' },
  { label: 'Icom', value: 'Maintenance::Avionics::Manufacturers::Icom' },
  { label: 'Insight', value: 'Maintenance::Avionics::Manufacturers::Insight' },
  { label: 'JP', value: 'Maintenance::Avionics::Manufacturers::JP' },
  { label: 'KGB Aviation Solutions', value: 'Maintenance::Avionics::Manufacturers::KGB Aviation Solutions' },
  { label: 'L-3', value: 'Maintenance::Avionics::Manufacturers::L-3' },
  { label: 'Mid-Continent', value: 'Maintenance::Avionics::Manufacturers::Mid-Continent' },
  { label: 'Narco', value: 'Maintenance::Avionics::Manufacturers::Narco' },
  { label: 'PS Engineering', value: 'Maintenance::Avionics::Manufacturers::PS Engineering' },
  { label: 'Rockwell Collins', value: 'Maintenance::Avionics::Manufacturers::Rockwell Collins' },
  { label: 'S-TEC', value: 'Maintenance::Avionics::Manufacturers::S-TEC' },
  { label: 'Sandel', value: 'Maintenance::Avionics::Manufacturers::Sandel' },
  { label: 'Sandia Aerospace', value: 'Maintenance::Avionics::Manufacturers::Sandia Aerospace' },
  { label: 'Shadin', value: 'Maintenance::Avionics::Manufacturers::Shadin' },
  { label: 'TKM', value: 'Maintenance::Avionics::Manufacturers::TKM' },
  { label: 'Technisonic', value: 'Maintenance::Avionics::Manufacturers::Technisonic' },
  { label: 'Trig Avionics', value: 'Maintenance::Avionics::Manufacturers::Trig Avionics' },
  { label: 'Trio Avionics', value: 'Maintenance::Avionics::Manufacturers::Trio Avionics' },
  { label: 'TruTrack Flight Systems', value: 'Maintenance::Avionics::Manufacturers::TruTrack Flight Systems' },
  { label: 'Universal Avionics', value: 'Maintenance::Avionics::Manufacturers::Universal Avionics' },
  { label: 'Vertex Standard', value: 'Maintenance::Avionics::Manufacturers::Vertex Standard' },
  { label: 'uAvionix', value: 'Maintenance::Avionics::Manufacturers::uAvionix' },
];

export const SERVICE_REPAIR_POWERPLANT_OPTIONS: ServiceRepairFacetOption[] = [
  { label: '100 Hour Inspection', value: 'Maintenance::Powerplant::100 Hour Inspection' },
  { label: '50 Hour Inspection', value: 'Maintenance::Powerplant::50 Hour Inspection' },
  { label: 'Annual Inspection', value: 'Maintenance::Powerplant::Annual Inspection' },
  { label: 'FAA Repair Station', value: 'Maintenance::Powerplant::FAA Repair Station' },
  { label: 'Major repair', value: 'Maintenance::Powerplant::Major repair' },
  { label: 'Minor repair', value: 'Maintenance::Powerplant::Minor repair' },
  { label: 'Piston', value: 'Maintenance::Powerplant::Piston' },
  { label: 'Pre-sales Inspection', value: 'Maintenance::Powerplant::Pre-sales Inspection' },
  { label: 'Progressive/Phase Inspection', value: 'Maintenance::Powerplant::Progressive/Phase Inspection' },
  { label: 'Radial', value: 'Maintenance::Powerplant::Radial' },
  { label: 'Rotary', value: 'Maintenance::Powerplant::Rotary' },
  { label: 'Turbofan', value: 'Maintenance::Powerplant::Turbofan' },
  { label: 'Turbojet', value: 'Maintenance::Powerplant::Turbojet' },
  { label: 'Turboprop', value: 'Maintenance::Powerplant::Turboprop' },
  { label: 'Turboshaft', value: 'Maintenance::Powerplant::Turboshaft' },
  { label: 'Ultralight', value: 'Maintenance::Powerplant::Ultralight' },
];

export const SERVICE_REPAIR_POWERPLANT_MANUFACTURER_OPTIONS: ServiceRepairFacetOption[] = [
  { label: 'Agusta', value: 'Maintenance::Powerplant::Manufacturers::Agusta' },
  { label: 'Alfa Romeo', value: 'Maintenance::Powerplant::Manufacturers::Alfa Romeo' },
  { label: 'Allison', value: 'Maintenance::Powerplant::Manufacturers::Allison' },
  { label: 'Continental', value: 'Maintenance::Powerplant::Manufacturers::Continental' },
  { label: 'FAA Repair', value: 'Maintenance::Powerplant::Manufacturers::FAA Repair' },
  { label: 'Garrett', value: 'Maintenance::Powerplant::Manufacturers::Garrett' },
  { label: 'General Electric', value: 'Maintenance::Powerplant::Manufacturers::General Electric' },
  { label: 'Honeywell', value: 'Maintenance::Powerplant::Manufacturers::Honeywell' },
  { label: 'Jacobs', value: 'Maintenance::Powerplant::Manufacturers::Jacobs' },
  { label: 'Lycoming', value: 'Maintenance::Powerplant::Manufacturers::Lycoming' },
  { label: 'Pratt and Whitney', value: 'Maintenance::Powerplant::Manufacturers::Pratt and Whitney' },
  { label: 'Renault', value: 'Maintenance::Powerplant::Manufacturers::Renault' },
  { label: 'Rolls-Royce', value: 'Maintenance::Powerplant::Manufacturers::Rolls-Royce' },
  { label: 'Rotax', value: 'Maintenance::Powerplant::Manufacturers::Rotax' },
  { label: 'Teledyne', value: 'Maintenance::Powerplant::Manufacturers::Teledyne' },
  { label: 'Turbomeca', value: 'Maintenance::Powerplant::Manufacturers::Turbomeca' },
  { label: 'Westinghouse', value: 'Maintenance::Powerplant::Manufacturers::Westinghouse' },
  { label: 'Williams', value: 'Maintenance::Powerplant::Manufacturers::Williams' },
];

export const SERVICE_REPAIR_PROPELLER_OPTIONS: ServiceRepairFacetOption[] = [
  { label: 'Constant Speed', value: 'Maintenance::Propeller::Constant Speed' },
  { label: 'Contra-rotating', value: 'Maintenance::Propeller::Contra-rotating' },
  { label: 'Dynamic Balancing', value: 'Maintenance::Propeller::Dynamic Balancing' },
  { label: 'FAA Repair Station', value: 'Maintenance::Propeller::FAA Repair Station' },
  { label: 'Fixed Pitch', value: 'Maintenance::Propeller::Fixed Pitch' },
];

export const SERVICE_REPAIR_PROPELLER_MANUFACTURER_OPTIONS: ServiceRepairFacetOption[] = [
  { label: 'Avia', value: 'Maintenance::Propeller::Manufacturers::Avia' },
  { label: 'Hamilton', value: 'Maintenance::Propeller::Manufacturers::Hamilton' },
  { label: 'Hartzell', value: 'Maintenance::Propeller::Manufacturers::Hartzell' },
  { label: 'Hoffman', value: 'Maintenance::Propeller::Manufacturers::Hoffman' },
  { label: 'MT Propeller', value: 'Maintenance::Propeller::Manufacturers::MT Propeller' },
  { label: 'McCauley', value: 'Maintenance::Propeller::Manufacturers::McCauley' },
  { label: 'Sensenich', value: 'Maintenance::Propeller::Manufacturers::Sensenich' },
];

export const SERVICE_REPAIR_INTERIOR_OPTIONS: ServiceRepairFacetOption[] = [
  { label: 'Audio Entertainment', value: 'Maintenance::Interior::Audio Entertainment' },
  { label: 'Fabric', value: 'Maintenance::Interior::Fabric' },
  { label: 'Leather', value: 'Maintenance::Interior::Leather' },
  { label: 'Oxygen', value: 'Maintenance::Interior::Oxygen' },
  { label: 'Vinyl', value: 'Maintenance::Interior::Vinyl' },
];

export const SERVICE_REPAIR_EXTERIOR_OPTIONS: ServiceRepairFacetOption[] = [
  { label: 'Painting', value: 'Maintenance::Exterior::Painting' },
  { label: 'Touch-Up Paint', value: 'Maintenance::Exterior::Touch-Up Paint' },
];

export const SERVICE_REPAIR_ROTOR_OPTIONS: ServiceRepairFacetOption[] = [
  { label: 'Rotor Blades', value: 'Maintenance::Rotor::Rotor Blades' },
];

/**
 * Filter state for the Service/Repair Finder. Holds the keyword plus the selected category facets, stored as
 * arrays of Maintenance:: tag names so the OR/AND filtering logic (see SearchPageComponent.filterServiceRepairs)
 * can match directly against ServiceRepairResult.tags. Empty arrays mean "no constraint" (show all). Mirrors
 * {@link FboFinderFilter}.
 */
export class ServiceRepairFinderFilter {

  /** Keyword: business name or airport ident. */
  name = '';


  /** Selected Airframe services tag names (AND logic). */
  airframe: string[] = [];

  /** Selected Airframe manufacturers tag names (OR logic). */
  airframeManufacturers: string[] = [];

  /** Selected Avionics services tag names (AND logic). */
  avionics: string[] = [];

  /** Selected Avionics manufacturers tag names (OR logic). */
  avionicsManufacturers: string[] = [];

  /** Selected Powerplant services tag names (AND logic). */
  powerplant: string[] = [];

  /** Selected Powerplant manufacturers tag names (OR logic). */
  powerplantManufacturers: string[] = [];

  /** Selected Propeller services tag names (AND logic). */
  propeller: string[] = [];

  /** Selected Propeller manufacturers tag names (OR logic). */
  propellerManufacturers: string[] = [];

  /** Selected Interior services tag names (AND logic). */
  interior: string[] = [];

  /** Selected Exterior services tag names (AND logic). */
  exterior: string[] = [];

  /** Selected Rotor services tag names (AND logic). */
  rotor: string[] = [];

}
